// ✅ Universal Bangladeshi Mobile Validator
export const validateMobile = async (_: any, value: string) => {
  if (!value) {
    return Promise.resolve();
  }

  // Step 1: only allow digits and optional + at start
  const digitsOnlyRegex = /^\+?\d+$/;
  if (!digitsOnlyRegex.test(value)) {
    return Promise.reject(new Error('Phone number must contain only numbers'));
  }

  // Step 2: validate BD mobile number
  // Accepts:
  // +8801XXXXXXXXX  → e.g. +8801933333333
  // 8801XXXXXXXXX   → e.g. 8801933333333
  // 01XXXXXXXXX     → e.g. 01933333333
  // 1XXXXXXXXX      → e.g. 1933333333
  const phoneRegex = /^(?:\+?88)?0?1[3-9]\d{8}$/;

  if (!phoneRegex.test(value)) {
    return Promise.reject(
      new Error('Please enter a valid Bangladeshi mobile number'),
    );
  }

  return Promise.resolve();
};
